import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ROUTE_TITLE_MAP: Record<string, string> = {
  '/': 'pageTitle.dashboard',
  '/home': 'pageTitle.dashboard',
  '/dashboard': 'pageTitle.dashboard',
  '/home/plan-documents': 'common.planDocuments',
  '/home/covered-eligible-members': 'common.coveredEligibleMembers',
  '/home/your-plan': 'common.myPlan',
  '/home/benefits': 'common.benefits',
  '/home/member-id-card': 'common.memberIDCard',
  '/home/enroll-benefits': 'dashboard.benefitsTitle',
  '/home/authorizations': 'common.authorizations',
  '/home/authorizations/authorizationDetails': 'common.authorizations',
  '/home/forms-and-documents': 'common.formsDocuments',
  '/profile': 'common.profile',
  '/home/member-profile': 'common.memberProfile',
  '/home/medical-claims': 'common.medicalClaimsExplanation',
  '/account/activation': 'pageTitle.registration',
  '/home/contact-us': 'common.contactUs',
  '/home/wellness-programs': 'common.wellnessPrograms',
  '/home/physical-therapy': 'physicalTherapy.physicalTherapy',
  '/home/pharmacy-tools': 'pageTitle.pharmacyTools',
  '/home/claims-summary': 'pageTitle.claimsSummary',
  '/home/eob-claims': 'pageTitle.superEOBClaims',
  '/home/related-claims': 'pageTitle.superRelatedClaims',
  '/login/forgot-username': 'pageTitle.forgotUsername',
  '/reset-password': 'pageTitle.resetPassword',
  '/home/proxy-approval': 'pageTitle.approval',
  '/contact-us': 'common.contactUs',
  '/sign-in': 'common.signIn',
  '/home/pay-your-sentara-bill': 'common.payYourSentaraBill',
  '/home/pay-monthly-premium': 'common.payMonthlyPremium',
  '/contexts/': 'pageTitle.launchDarklyKey',
  '/home/view-tax-summary': 'pageTitle.dropdownValue',
  '/proxy-expired-form': 'pageTitle.proxyExpiredForm',
  '/account/activationChildOnlyPlan': 'pageTitle.registrationProxy',
  '/home/find-a-doctor': 'common.findADoctor',
  '/home/change-primary-care-provider': 'common.changePrimaryCare',
  '/home/behavioral-claims': 'common.behavioral',
  '/home/pharmacy-claims': 'common.pharmacy',
  '/home/hinge-health': 'common.jointMusclePainReliefProgram',
  '/home/virtual-visit-care': 'virtualVisitCare.virtualVisit'
};

export function usePageTitle(): void {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Find the first route pattern that matches the current pathname
    const matchedPattern = Object.keys(ROUTE_TITLE_MAP).find((pattern) =>
      matchPath({ path: pattern, end: true }, pathname),
    );

    // If no match, fallback to 404 title
    const pageTitleId = matchedPattern
      ? ROUTE_TITLE_MAP[matchedPattern]
      : 'pageTitle.404';

    // Prefix + page title
    document.title = t('common.titlePrefix') + t(pageTitleId);
  }, [pathname, t]);
}
